import { createSlice } from '@reduxjs/toolkit';
import CustomAxios from '../utilities/service/api.service';
import CheckAuthorization from '../utilities/auth/checkAuthorization';
import { API } from '../utilities/constants';
import { showErrorMessage } from '../utilities/helperFns';


const initialState = {
    nielsen_bookmark_loader: false,
    epos_bookmark_loader: false,
    bookmarksNielsen: [],
    bookmarksEpos: []
};

const bookmarkSlicer = createSlice({
    name: 'bookmarks',
    initialState,
    reducers: {
        setNielsenBookmarkLoader: (state, action) => ({
            ...state,
            nielsen_bookmark_loader: action.payload,
        }),
        setEposBookmarkLoader: (state, action) => ({
            ...state,
            epos_bookmark_loader: action.payload,
        }),
        setBookmarksNielsen: (state, action) => ({
            ...state,
            bookmarksNielsen: action.payload,
        }),
        setBookmarksEpos: (state, action) => ({
            ...state,
            bookmarksEpos: action.payload,
        })
    },
})

export const {
    setNielsenBookmarkLoader,
    setEposBookmarkLoader,
    setBookmarksNielsen,
    setBookmarksEpos
} = bookmarkSlicer.actions
//function to obtain the bookmarks in Nielsen page
export const getNielsenBookmarks = (nielsen_dataset) => (dispatch, getState) => {
    let dataset = nielsen_dataset
    CustomAxios(API.apply_bookmark + '?dataset=' + dataset, 'GET').then((response) => {

        if (response) {
            dispatch(setBookmarksNielsen(response.data))
        }
        if (response.status === 200) {
        }
    }).catch((err) => {
        if (err.status === 403) {
            CheckAuthorization()
        }
        showErrorMessage()
    })
}
//function to obtain the bookmarks in EPOS page
export const getEposBookmarks = (epos_dataset) => (dispatch, getState) => {
    let dataset = epos_dataset
    CustomAxios(API.apply_bookmark + '?dataset=' + dataset, 'GET').then((response) => {

        if (response) {
            dispatch(setBookmarksEpos(response.data))
        }
    }).catch((err) => {
        if (err.status === 403) {
            CheckAuthorization()
        }
        showErrorMessage()
    })
}



export default bookmarkSlicer.reducer